import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'

import { defineNuxtPlugin } from 'nuxt/app'

// Register the dayjs `duration` plugin at app boot, before any component in this
// layer renders (SSR + client). The event banner countdown calls
// `dayjs.duration(...)`; relying on a top-level `extend()` side-effect inside a
// util module let bundlers tree-shake/reorder it, so a lazy-loaded call site
// could run first and throw `TypeError: x.duration is not a function`
// (Sentry CLIENTPORTAL-NUXT-5).
//
// Scoped to this layer on purpose: only apps that extend events-layer load it,
// so apps like meet (which do not) never pay for a plugin they don't use.
dayjs.extend(duration)

export default defineNuxtPlugin(() => {})
